var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 182,
    viewBox: "0 0 248 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.007 137.703C124.795 137.703 125.434 137.066 125.434 136.279C125.434 135.493 124.795 134.855 124.007 134.855C123.219 134.855 122.58 135.493 122.58 136.279C122.58 137.066 123.219 137.703 124.007 137.703Z",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5605 30.4829V36.7319",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.416 33.6074H85.6906",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.823 69.8952C141.638 69.8952 129.234 69.4011 117.632 66.1749C106.247 63.0213 95.7942 56.9032 86.4769 49.8259C80.377 45.2191 74.8303 41.5424 66.9106 42.0946C59.1628 42.5131 51.7537 45.4012 45.772 50.3345C35.6977 59.1412 37.2117 75.4611 41.2444 86.8836C47.3006 104.134 65.7314 116.152 81.396 123.927C99.492 132.951 119.379 138.198 139.309 141.206C156.779 143.865 179.228 145.784 194.368 134.405C208.271 123.927 212.086 100.035 208.679 83.9045C207.852 79.1391 205.31 74.8392 201.531 71.8135C191.762 64.678 177.189 69.4447 166.212 69.6772C162.136 69.7644 157.987 69.8661 153.823 69.8952Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.11 21.967C134.898 21.967 135.537 21.3294 135.537 20.5428C135.537 19.7563 134.898 19.1187 134.11 19.1187C133.322 19.1187 132.684 19.7563 132.684 20.5428C132.684 21.3294 133.322 21.967 134.11 21.967Z",
    fill: "#989898"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9805 132.864V139.113",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8496 135.989H63.1097",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.59 169.486C154.106 169.486 178.033 167.996 178.033 166.158C178.033 164.32 154.106 162.83 124.59 162.83C95.0739 162.83 71.1465 164.32 71.1465 166.158C71.1465 167.996 95.0739 169.486 124.59 169.486Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.551 130.51H75.2372C74.6194 130.51 74.0091 130.375 73.4484 130.116C72.8878 129.857 72.3902 129.48 71.9901 129.01C71.59 128.54 71.2969 127.989 71.1311 127.395C70.9653 126.801 70.9307 126.178 71.0298 125.569L82.8366 54.0983C82.9961 53.1036 83.5061 52.1984 84.2748 51.5457C85.0434 50.893 86.0202 50.5356 87.0294 50.5379H179.343C179.961 50.5379 180.571 50.6722 181.131 50.9314C181.691 51.1905 182.188 51.5684 182.587 52.0386C182.986 52.5088 183.277 53.0601 183.441 53.6543C183.605 54.2484 183.638 54.871 183.536 55.4789L171.788 126.95C171.624 127.95 171.107 128.86 170.33 129.513C169.553 130.166 168.567 130.52 167.551 130.51Z",
    fill: "#BFBFBF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M168.689 48.6688L113.893 24.2468C112.278 23.5269 110.384 24.2504 109.663 25.8627L92.2963 64.6903C91.5751 66.3027 92.2999 68.1933 93.9151 68.9132L148.711 93.3351C150.326 94.055 152.22 93.3315 152.941 91.7192L170.308 52.8916C171.029 51.2793 170.304 49.3886 168.689 48.6688Z",
    fill: "white",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M121.926 56.1909C123.368 54.1707 125.466 52.7104 127.863 52.0574C130.261 51.4045 132.811 51.599 135.081 52.6082C137.351 53.6173 139.202 55.3789 140.32 57.5945C141.438 59.8101 141.755 62.3434 141.215 64.7651",
    stroke: "#828282",
    strokeWidth: 0.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.13 53.9966C148.959 53.9966 149.63 53.3265 149.63 52.4998C149.63 51.6731 148.959 51.0029 148.13 51.0029C147.302 51.0029 146.631 51.6731 146.631 52.4998C146.631 53.3265 147.302 53.9966 148.13 53.9966Z",
    fill: "#828282"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.41 44.3179C127.238 44.3179 127.909 43.6477 127.909 42.8211C127.909 41.9944 127.238 41.3242 126.41 41.3242C125.582 41.3242 124.91 41.9944 124.91 42.8211C124.91 43.6477 125.582 44.3179 126.41 44.3179Z",
    fill: "#828282"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.142 130.481H74.3772C73.2485 130.477 72.1672 130.027 71.3704 129.229C70.5736 128.431 70.1262 127.35 70.1262 126.223V60.9286C70.1127 60.3621 70.2125 59.7987 70.4199 59.2712C70.6272 58.7438 70.938 58.263 71.3339 57.8569C71.7298 57.4509 72.2029 57.1278 72.7255 56.9066C73.2481 56.6855 73.8096 56.5706 74.3772 56.5688H108.167C108.951 56.5717 109.719 56.7903 110.387 57.2005C111.055 57.6107 111.596 58.1966 111.952 58.894L116.771 68.3111C117.125 69.0095 117.667 69.5964 118.335 70.0068C119.003 70.4172 119.772 70.635 120.556 70.6363H167.142C168.27 70.6363 169.351 71.0833 170.148 71.8791C170.946 72.675 171.393 73.7543 171.393 74.8797V126.223C171.394 127.35 170.946 128.431 170.149 129.229C169.352 130.027 168.271 130.477 167.142 130.481Z",
    fill: "white",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.861 72.8596C147.502 72.8567 142.263 74.4405 137.805 77.4104C133.348 80.3804 129.873 84.6033 127.82 89.5448C125.768 94.4864 125.229 99.9246 126.273 105.172C127.316 110.419 129.896 115.239 133.684 119.023C137.473 122.807 142.3 125.384 147.556 126.429C152.812 127.473 158.26 126.939 163.211 124.892C168.163 122.846 172.395 119.379 175.373 114.931C178.35 110.484 179.94 105.254 179.94 99.9045C179.94 92.7343 177.087 85.8575 172.01 80.786C166.932 75.7145 160.044 72.8635 152.861 72.8596Z",
    fill: "white",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M172.137 119.523L179.358 126.731",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.541 123.229L176.297 125.572C175.292 126.622 175.329 128.287 176.381 129.291L195.85 147.869C196.902 148.873 198.57 148.835 199.575 147.785L201.818 145.442C202.824 144.392 202.787 142.727 201.735 141.723L182.266 123.146C181.214 122.142 179.546 122.179 178.541 123.229Z",
    fill: "#BFBFBF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.955 20.5427V26.8062",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.811 23.6819H196.085",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/no-data-available.d96e2ba7e323b1dd66918c7e59d10385.svg";
export { ForwardRef as ReactComponent };